import Bowser from "bowser"
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Cookies from 'js-cookie'
import { uniqueNamesGenerator, adjectives, colors, animals } from 'unique-names-generator'

async function get_fingerprint() {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  return result.visitorId
}

const extension_resources = [
  // {url: 'chrome-extension://bmnlcjabgnpnenekpadlanbbkooimhnj/paypal/button.js', name: 'Honey', tags: ['personal']},

  // {url: 'chrome-extension://niloccemoadcdkdjlinkgdfekeahmflj/save.html', name: 'Pocket', tags: ['personal']},
  // {url: 'chrome-extension://kbfnbcaeplbcioakkpcpgfkobkghlhen/src/popupEditorIFrame.html', name: 'Grammarly', tags: []},

  // {url: 'chrome-extension://noojglkidnpfjbincgijbaiedldjfbhh/manifest.json', name: 'Buffer', tags: ['marketing', 'social_media']},
  // {url: 'chrome-extension://bjgfdlplhmndoonmofmflcbiohgbkifn/images/rss/arrow.png', name: 'Hootsuite Hootlet', tags: ['marketing', 'social_media']},
  // {url: 'chrome-extension://eakacpaijcpapndcfffdgphdiccmpknp/images/mozicon_19x19.png', name: 'MozBar', tags: ['marketing', 'seo']},
  // {url: 'chrome-extension://cknebhggccemgcnbidipinkifmmegdel/html/content/toolbar.html', name: 'SEO Analysis & Website Review by WooRank', tags: ['marketing', 'seo']},

  // {url: 'chrome-extension://kgjfgplpablkjnlkjmjdecgdpfankdle/images/loading_24.gif', name: 'Zoom Scheduler', tags: ['buisness']},

  {url: 'chrome-extension://oiiaigjnkhngdbnoookogelabohpglmd/img/hubspot-logo-16-grey.png', name: 'HubSpot Sales', tags: ['sales']},
  {url: 'chrome-extension://liecbddmkiiihnedobmlmillhodjkdmb/css/content.css', name: 'Loom', tags: ['sales']},
  {url: 'chrome-extension://jiihcciniecimeajcniapbngjjbonjan/popup.html', name: 'Vidyard', tags: ['sales']},
  // {url: 'chrome-extension://nmaonghoefpmlfgaknnboiekjhfpmajh/sidebar.html', name: 'Crystal', tags: ['sales']},
  {url: 'chrome-extension://chmpifjjfpeodjljjadlobceoiflhdid/assets/content/autoclose.html', name: 'Outreach Everywhere', tags: ['sales']},
  {url: 'chrome-extension://amcdijdgmckgkkahhcobikllddfbfidi/contentSrc/forLinkedin/XMLHttpWatcher.js', name: 'Reply.io', tags: ['sales']},
  // {url: 'chrome-extension://hgmhmanijnjhaffoampdlllchpolkdnj/html/source_popup.html', name: 'Hunter', tags: ['sales']},
  {url: 'chrome-extension://mfldbojpjpgjlphijlbgefdjebkhdjom/css/gmail.css', name: 'BombBomb', tags: ['sales']},

  // {url: 'chrome-extension://fmkadmapgofadopljbjfkapdkoienihi/main.html', name: 'React Developer Tools', tags: ['developer']},
  // {url: 'chrome-extension://nhdogjmejiglipccpnnnanhbledajbpd/devtools.html', name: 'Vue Developer Tools', tags: ['developer']},
  // {url: 'chrome-extension://bhlhnicpbhignbdhedgjhgdocnmhomnp/css/content-style.css', name: 'ColorZilla', tags: ['developer', 'designer']},
  // {url: 'chrome-extension://aejoelaoggembcahagimdiliamlcdmfm/images/icon/favicon.ico', name: 'Talend API Tester - Free Edition', tags: ['developer']},
  //
  // {url: 'chrome-extension://hdokiejnpimakedhajhdlcegeplioahd/overlay.html', name: 'LastPass', tags: ['security']},
  // {url: 'chrome-extension://aeblfdkhhhdcdjpifhhbdiojplfjncoa/inline/menu/menu.html', name: '1Password', tags: ['security']},
  // {url: 'chrome-extension://fdjamakpfbbddfjaooikfcpapjohcfmg/content/webui/index.html', name: 'Dashlane', tags: ['security']},
]

export default {
  data() {
    return {
      visitor: null,
      extensions: null
    }
  },
  methods: {
    uuid() {
      return Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9) + Math.random().toString(36).substr(2, 9)
    },
    async website_visitor() {
      let visitor = Cookies.get('3rdeye')

      if (!visitor) {
        let fingerprint = await get_fingerprint()
        let seed = parseInt(fingerprint, 16) % 999999999999999

        let name = uniqueNamesGenerator({seed: seed, style: 'capital', separator: ' ', dictionaries: [adjectives, colors, animals]})

        visitor = {
          id: this.uuid(),
          fingerprint: fingerprint,
          name: name
        }
      } else {
        visitor = JSON.parse(visitor)
      }

      return visitor
    },
    async tracking_data(extensions) {
      if (extensions && this.extensions === null) {
        this.extensions = await this.test_extensions()

        if (this.visitor) {
          this.visitor.extensions = this.extensions
        }
      }

      if (this.visitor) {
        return this.visitor
      }

      if (window.navigator.userAgent.match(/bot/i)) {
        console.log('Bot detected and ignored')
        return
      }

      let visitor = await this.website_visitor()
      window.visitor = visitor

      const browser = Bowser.getParser(window.navigator.userAgent)
      let geo = await this.track_geo()

      let timezone = null
      try {
        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      } catch (err) {
        // Pass
      }

      visitor.platform = browser.getPlatform().type
      visitor.os = browser.getOSName()
      visitor.browser = browser.getBrowser().name

      visitor.created = new Date()

      visitor.city = geo.city || null
      visitor.postal_code = geo.postal || null
      visitor.country = geo.country_name || null

      visitor.region = geo.region || null
      visitor.country_code = geo.country_code || null
      visitor.gdpr_applicable = geo.is_eu || null
      visitor.metro_code = geo.metroCode || null
      visitor.latitude = geo.latitude || null
      visitor.longitude = geo.longitude || null
      visitor.utc_offset = new Date().getTimezoneOffset() * -1
      visitor.local_hour = new Date().getHours()
      visitor.timezone = timezone
      visitor.day_of_week = new Date().getDay()
      visitor.href = window.location.href || null
      visitor.referrer = document.referrer || null

      visitor.is_anonymous = geo.threat.is_anonymous || null
      visitor.is_threat = geo.threat.is_threat || null

      visitor.clearbit = await this.track_clearbit()

      // TODO bot detection
      // bots, tor, proxy, anonymous, known attacker, known abuser

      visitor.extensions = this.extensions

      visitor.ip = geo.ip || null
      visitor.profiled = true

      this.visitor = visitor

      Cookies.set('3rdeye', JSON.stringify(visitor))

      return visitor
    },
    async track_clearbit() {
      try {
        let response = await fetch(`https://reveal.clearbit.com/v1/companies/reveal?authorization=pk_a7bb4cb2fcda3017eb148eeffe8438d7`, {method: 'GET'})

        if (response.status === 404) {
          return {success: true, response: null}
        }

        if (!response.ok) {
          throw new Error('error fetching clearbit')
        }

        let json = await response.json()
        return {success: true, response: json || null}
      } catch (err) {
        // console.error(err) // TODO
        return {success: false, message: err.message || null}
      }
    },
    async track_geo() {
      let geo = {
        city: 'FAIL',
        postal: 'FAIL',
        country_name: 'FAIL',
        region: 'FAIL',
        country_code: 'FAIL',
        is_eu: 'FAIL',
        metroCode: 'FAIL',
        latitude: 'FAIL',
        longitude: 'FAIL',
        ip: 'FAIL',
        threat: {is_anonymous: null, is_threat: null},
      }

      try { // fallback
        let response = await fetch(`https://customer.api.drift.com/geo/v2`, {method: 'GET'})

        if (!response.ok) {
          throw new Error('error fetching ipdata')
        }

        let geo2 = await response.json()

        geo.city = geo2.city
        geo.postal = geo2.postalCode
        geo.country_name = geo2.countryName
        geo.region = geo2.subdivision
        geo.country_code = geo2.country
        geo.is_eu = geo2.gdprApplicable
        geo.metroCode = geo2.metroCode
        geo.latitude = geo2.latitude
        geo.longitude = geo2.longitude
        geo.ip = geo2.ip

        return geo
      } catch (err) {
        console.warn(err)
      }

      return geo
    },
    async test_extensions() {
      let extensions = []
      for (let resource of extension_resources) {
        try {
          let r = await fetch(resource.url, {method: 'GET'})
          if (r.status === 200) {
            extensions.push(resource.name)
          }
        } catch (err) {
          // Failed to fetch, ignore
        }
      }
      // TODO adblock

      return extensions
    }
  },
}
